import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import NotificationSystem from "react-notification-system";
import AdminNavbar from "components/Navbars/AdminNavbar";
import Footer from "components/Footer/Footer";
import Sidebar from "components/Sidebar/Sidebar";
import { style } from "variables/Variables.jsx";
import image from "assets/img/sidebar-2.jpg";
import IdleTimeContainer from 'components/idleTimeContainer'; 
import { RedisDataContext } from "context/RedisDataContext";
import { GlobalLoadIndicator } from "context/GlobalLoadIndicator";
import BeatLoader from "react-spinners/BeatLoader";
import Cookies from 'universal-cookie'
import { isEmpty } from "components/Login/validator";

const cookies = new Cookies();
class Admin extends Component {
  static contextType = RedisDataContext;

  constructor(props) {
    super(props);
    this.state = {
      _notificationSystem: null,
      image: image,
      prefixTabTitle : document.title,
      featureTiltle : '',
      color: "black",
      hasImage: true,
      isTimeout: false,
      fixedClasses: "dropdown show-dropdown open",
      globalLoadIndicator: GlobalLoadIndicator
    };
  }

  handleNotificationClick = position => {    
    localStorage.setItem('activeWalletClientName', position.name);
    localStorage.setItem('activeWalletClientToken', position.clientToken);
    localStorage.setItem('activeWalletClientCustomerID', position.customerId);
  };

  getRoutes = routes => {

    return routes.map((prop, key) => {
      const ComponentToRender = require("../views/" + prop.component + '.jsx').default;

      if (prop.submenu == false) {
        if (prop.layout === "/admin") {
          return (
            <Route
              path={prop.layout + prop.path}
              render={props => (
                <ComponentToRender
                  {...props}
                  handleClick={this.handleNotificationClick}
                />
              )}
              key={key}
            />
          );
        } else {
          return null;
        }
      } else {
        if (prop.layout === "/admin") {
          return prop.submenuitem.map((childItem, childKey) => {
            const ComponentToRender = require("../views/" + childItem.component + '.jsx').default;
            return (
              <Route
                path={childItem.layout + childItem.path}
                render={props => (
                  <ComponentToRender
                    {...props}
                    handleClick={this.handleNotificationClick(childItem)}
                  />
                )}
                key={key + '.' + childKey}
              />
            );
          });
        }
        else {
          return null;
        }
      }

    });
  };

  getBrandText = path => {
    for (let i = 0; i < this.context.length; i++) {
      if (
        this.props.location.pathname.indexOf(
          this.context[i].layout + this.context[i].path
        ) !== -1
      ) {
        return this.context[i].name;
      }
    }
    return "Brand";
  };

  handleImageClick = image => {
    this.setState({ image: image });
  };

  handleColorClick = color => {
    this.setState({ color: color });
  };

  handleHasImage = hasImage => {
    this.setState({ hasImage: hasImage });
  };

  handleFixedClick = () => {
    if (this.state.fixedClasses === "dropdown") {
      this.setState({ fixedClasses: "dropdown show-dropdown open" });
    } else {
      this.setState({ fixedClasses: "dropdown" });
    }
  };

  componentDidMount() {
    try {
      this.setState({ _notificationSystem: this.refs.notificationSystem });
      var _notificationSystem = this.refs.notificationSystem;
      var color = Math.floor(Math.random() * 4 + 1);
      var level;
      switch (color) {
        case 1:
          level = "warning";
          break;
        case 2:
          level = "warning";
          break;
        case 3:
          level = "warning";
          break;
        case 4:
          level = "warning";
          break;
        default:
          break;
      }
      _notificationSystem.addNotification({
        title: <span data-notify="icon" className="" />,
        message: (
          localStorage.getItem("i18nextLng") === "chi" ?
            <div className="notification-text" >
              欢迎来到<b>Eseal</b>
            </div> :
            <div className="notification-text" >
              Welcome to <b>Eseal</b>
            </div>
        ),
        level: level,
        position: "tr",
        autoDismiss: 2
      });
  
      const path = this.props.location.pathname;
      const lastParam = path.substring(path.lastIndexOf('/') + 1);
      this.setState({ featureTiltle: lastParam.replace(/\w\S*/g, function (t) { return t.charAt(0).toUpperCase() + t.substr(1).toLowerCase(); }) })
      const timer = new IdleTimeContainer({
        inactivityTime: 6 * 60 * 60,
        expirationTime: 3 * 24 * 60 * 60,
        onTimeout: () => {
          this.setState({ isTimeout: true });
        },
        onExpired: () => {
          this.setState({ isTimeout: true });
        }
      });
      this.timer = timer;
  
      if (this.props.location.pathname === '/admin/home' && this.state.featureTiltle === 'Home') {
        document.title = `${this.state.prefixTabTitle} - ${this.state.featureTiltle}`;
        cookies.set('title', `${this.state.prefixTabTitle}`, { path: '/' });
      }
    } catch (e) {
      this.props.setHasError({
        error: true,
        message: e
      })
    }
  }

  componentDidUpdate(e) {
    if (
      window.innerWidth < 993 &&
      e.history.location.pathname !== e.location.pathname &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
    }
    if (e.history.action === "PUSH") {
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      this.refs.mainPanel.scrollTop = 0;
    }
  }

  //this method navigates the correct feauture when user edit the path in browser.
  componentDidUpdate = (e) => {
    this.context.forEach(contextRoutes => {
      if(contextRoutes.submenu){
        contextRoutes.submenuitem.forEach(subRoutes => {
          if(`/admin${subRoutes.path}` == e.location.pathname){
            cookies.set('feature_id', subRoutes.featureId, { path: '/' });
            cookies.set('pagetype_id', subRoutes.pageTypeId, { path: '/' });
          }
        })
      }
    })
  }

  componentWillUnmount() {
    if (this.timer) {
      this.timer.logout();
    }
  }

  render() {
    const homeTitle = `${this.state.prefixTabTitle} - ${this.state.featureTiltle}`
    if(this.props.location.pathname === '/admin/home' && this.state.featureTiltle === 'Home'){
      document.title = homeTitle
      cookies.set('title', `${this.state.prefixTabTitle}`, { path: '/' })
      }
    if (this.state.isTimeout === true) {
      const { history, location } = this.props;
      if (window.location.pathname !== "/login") {
        cookies.remove('accessToken',{ path: '/' });
        cookies.remove('user_id',{ path: '/' });
        cookies.remove('userLocation_id',{ path: '/' });
        cookies.remove('userRole_name',{ path: '/' });
        cookies.remove('feature_id',{ path: '/' });
        cookies.remove('pagetype_id',{ path: '/' });
        cookies.remove('customer_type',{ path: '/' });
        cookies.remove('customer_id',{ path: '/' });
        cookies.remove('tabTitle',{ path: '/' });
        cookies.remove('title', {path: '/'});
        document.title = `${this.state.prefixTabTitle}`
        history.push("/login");
      }
    }
    let SwitchCondition = <Switch>{this.getRoutes(this.context)}</Switch>;
    if(isEmpty(this.getRoutes(this.context))){
      SwitchCondition = <div className="loader-container">
          <div className="login-loader">
            <BeatLoader size={15} margin={3} color={"#3C423C"} />
          </div>
        </div>;
    }

    return (
      <div className="wrapper">
        <NotificationSystem ref="notificationSystem" style={style} />
        <Sidebar {...this.props} routes={this.context} image={this.state.image}
          color={this.state.color}
          hasImage={this.state.hasImage}
          languageYmlExport = {this.languageYmlExport} />
        <div id="main-panel" className="main-panel" ref="mainPanel">
          <AdminNavbar
            {...this.props}
            brandText={this.getBrandText(this.props.location.pathname)}
          />
          { SwitchCondition }
          <Footer />
          {/*<FixedPlugin
            handleImageClick={this.handleImageClick}
            handleColorClick={this.handleColorClick}
            handleHasImage={this.handleHasImage}
            bgColor={this.state["color"]}
            bgImage={this.state["image"]}
            mini={this.state["mini"]}
            handleFixedClick={this.handleFixedClick}
            fixedClasses={this.state.fixedClasses}
          />*/}
        </div>
      </div>
    );
  }
}

export default Admin;
